import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-dropdown-select'
import Button from '../../../components/Button/Button'
import SuperAdminContext from '../../../hooks/SuperAdminContext'
import toast from 'react-hot-toast'
import Autocomplete from "react-google-autocomplete";
import { IoClose } from 'react-icons/io5';
import { handleGoogleApiLocation, handleInput } from 'Actions/commonAction/milleSearchFilterActions';
import { useDispatch, useSelector } from 'react-redux'

const SuperAdminPartnerFilter = ({
    partnerTypes,
    partnerPlans,
    setPartnerFilterOpen,
    setPartnerTypes,
    setPartnerPlans,
    setPartnerApplyFilterCount,
    setPartnerSectors,
    partnerSectors,
    setpartnerSortBy,
    setSortBy
}) => {

    const { location, enteredInputLocation } = useSelector((state) => state.milleSearchStates);
    const dispatch = useDispatch();

    const { setCurrentPage, setPartnerApplyFilterObject,
        parType, setParType,
        parPlan, setParPlan,
        parSector, setparSector, setIsMilleSearchFiltered,
        isSearched, superAdminPartnerSearch, handleAdminPartnerMeilisearch
    } = useContext(SuperAdminContext);

    useEffect(() => {
        var getFilterLength = parType.length + parPlan.length + location.length + parSector.length
        setPartnerApplyFilterCount(getFilterLength);
    }, [parType, parPlan, location, parSector])


    const handlePartnerSectors = (partnerSectorValue) => {
        setparSector(partnerSectorValue)

        if (partnerSectorValue.length > 0) {
            const checkIfValueIsOthers = partnerSectorValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = partnerSectors.map((partSect) => {
                    return partSect.label !== "Others" ? { ...partSect, disabled: true } : partSect
                })
                setPartnerSectors(ChangeOtherValuesToDisable)
            } else {
                const ChangeOtherValuesToDisable = partnerSectors.map((partSect) => {
                    return partSect.label === "Others" ? { ...partSect, disabled: true } : partSect
                })
                setPartnerSectors(ChangeOtherValuesToDisable)
            }
        } else {
            const ChangeDisableFalse = partnerSectors.map((partSect) => {
                return { ...partSect, disabled: false }
            })
            setPartnerSectors(ChangeDisableFalse)
        }
    }

    const handlePartnerTypes = (partnerTypeValue) => {
        setParType(partnerTypeValue)

        if (partnerTypeValue.length > 0) {
            const checkIfValueIsOthers = partnerTypeValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = partnerTypes.map((partTyp) => {
                    return partTyp.label !== "Others" ? { ...partTyp, disabled: true } : partTyp
                })
                setPartnerTypes(ChangeOtherValuesToDisable)
            } else {
                const ChangeOtherValuesToDisable = partnerTypes.map((partTyp) => {
                    return partTyp.label === "Others" ? { ...partTyp, disabled: true } : partTyp
                })
                setPartnerTypes(ChangeOtherValuesToDisable)
            }
        } else {
            const ChangeDisableFalse = partnerTypes.map((partTyp) => {
                return { ...partTyp, disabled: false }
            })
            setPartnerTypes(ChangeDisableFalse)
        }
    }

    const handlePartnerPlans = (partnerPlanValue) => {
        setParPlan(partnerPlanValue)

        if (partnerPlanValue.length > 0) {
            const checkIfValueIsOthers = partnerPlanValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = partnerPlans.map((partnerPlanVal) => {
                    return partnerPlanVal.label !== "Others" ? { ...partnerPlanVal, disabled: true } : partnerPlanVal
                })
                setPartnerPlans(ChangeOtherValuesToDisable)
            } else {
                const ChangeOtherValuesToDisable = partnerPlans.map((partnerPlanVal) => {
                    return partnerPlanVal.label === "Others" ? { ...partnerPlanVal, disabled: true } : partnerPlanVal
                })
                setPartnerPlans(ChangeOtherValuesToDisable)
            }
        } else {
            const ChangeDisableFalse = partnerPlans.map((partnerPlanVal) => {
                return { ...partnerPlanVal, disabled: false }
            })
            setPartnerPlans(ChangeDisableFalse)
        }
    }

    const initializeFilter = () => {
        setCurrentPage(0);
        setPartnerFilterOpen(false);
        setpartnerSortBy("");
        setSortBy('Date Latest');

        var getFilterLength = parType.length + parPlan.length + location.length + parSector.length
        setPartnerApplyFilterCount(getFilterLength);

        if (getFilterLength > 0) {
            setIsMilleSearchFiltered(true)
            var a = parType.map((v) => v.label)
            var b = parPlan.map((v) => v.label)
            var d = parSector.map((v) => v.label)
            const locationConvertion = location.map((v) => {
                const originalVal = v.split(',')
                const joinOriginalValue = originalVal.join('&&&&&')

                return joinOriginalValue
            })

            let object;
            object = {
                partner_type: a,
                plan: b[0] === "All" ? [] : b,
                location: locationConvertion,
                sector: d,
                search_text: isSearched ? superAdminPartnerSearch : ''
            }


            setPartnerApplyFilterObject(object)
            handleAdminPartnerMeilisearch(object)
        } else {
            toast.error('fields are empty');
        }
    }

    return (
        <div className="container">
            <div className='px-3 py-4'>
                <div className='mb-4'>
                    <h6 className='fw-bold'>Sectors</h6>
                    <Select
                        multi
                        color='#ffa32d'
                        style={{ fontSize: ".9rem" }}
                        className='rounded-1'
                        options={parSector?.length < 5 ? partnerSectors : []}
                        addPlaceholder={"Only 5 Skills Can be selected"}
                        onChange={handlePartnerSectors}
                        values={parSector}
                    />
                </div>

                <div className='mb-4'>
                    <h6 className='fw-bold'>Partner type</h6>
                    <Select
                        multi
                        color='#ffa32d'
                        style={{ fontSize: ".9rem" }}
                        className='rounded-1'
                        options={partnerTypes}
                        onChange={handlePartnerTypes}
                        values={parType}
                    />
                </div>

                <div className='mb-4'>
                    <h6 className='fw-bold'>Plan</h6>
                    <Select
                        color='#ffa32d'
                        style={{ fontSize: ".9rem" }}
                        className='rounded-1'
                        options={partnerPlans}
                        onChange={handlePartnerPlans}
                        searchable={false}
                        values={parPlan}
                    />
                </div>

                <div className='mb-4'>
                    <h6 className='fw-bold'>Location</h6>
                    <div className={location.length ? 'd-flex flex-wrap mb-2' : 'd-none'}>
                        {location.map((v) => (
                            <div className="col-6 py-1 pe-1">
                                <div className="autocomplete-location-card w-100 d-flex flex-wrap align-items-center">
                                    <div className="col-10">
                                        <p className='w-100 mb-0 text-break'>{v}</p>
                                    </div>
                                    <div className="col-2">
                                        <IoClose className='fs-5 cursorPointer' onClick={() => dispatch(handleGoogleApiLocation({ type: "delete", deletionData: v }))} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <Autocomplete
                        apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                        className='google-places-api '
                        onPlaceSelected={(place) => {
                            if (place) {
                                dispatch(handleGoogleApiLocation({ type: "push", place: place.address_components }))
                            }
                        }}
                        onChange={(e) => dispatch(handleInput({ field: 'location', value: e.target.value }))}
                        value={enteredInputLocation}
                        disabled={location.length === 5}
                    />
                </div>

                <div>
                    <Button id="superAdminEmployerFilterBtn" buttonType={"button"} className={"btn btn-brand-color w-100"} title={"Apply Filter"} functionOnchange={() => {
                        initializeFilter()
                    }} />
                </div>
            </div>
        </div>
    )
}

export default SuperAdminPartnerFilter